import { FlowNavigationContext } from "../../../shared/constants";
import { flowPages, SignupFlowSlug } from "../constants";

export function isPageAccessible(
  slug: SignupFlowSlug,
  context: FlowNavigationContext,
): boolean {
  const page = flowPages.find((p) => p.slug === slug);
  return page?.accessRequirements.every((req) => req(context)) ?? false;
}
